import { DesktopAppointmentSummary } from "./DesktopAppointmentSummary";
import { MobileAppointmentSummary } from "./MobileAppointmentSummary";

import { Media } from "~/components/Media";
import type { AppointmentDetails } from "~/utils/appointment.utils.server";

export interface AppointmentSummaryProps {
  showEmployeePlaceholder?: boolean;
  employee: Omit<AppointmentDetails["employee"], "id"> | null;
  location: AppointmentDetails["location"] | null;
  meetingType: AppointmentDetails["meetingType"] | null;
  office: Pick<
    AppointmentDetails["office"],
    "title" | "externalId" | "isVirtual" | "address" | "timeZone"
  > | null;
  possibility: Pick<NonNullable<AppointmentDetails["possibility"]>, "end" | "start"> | null;
  subject: Pick<AppointmentDetails["subject"], "externalId" | "title"> | null;
  isMobileCollapsible?: boolean;
}

export function AppointmentSummary(props: AppointmentSummaryProps) {
  return (
    <>
      <Media data-component="AppointmentSummaryContainer" data-variant="Desktop" showFor="desktop">
        <DesktopAppointmentSummary {...props} />
      </Media>
      <Media data-component="AppointmentSummaryContainer" data-variant="Mobile" showFor="mobile">
        <MobileAppointmentSummary {...props} />
      </Media>
    </>
  );
}
